import { useEffect, useRef, useCallback } from 'react';
import { io, Socket } from 'socket.io-client';

const SOCKET_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5001/api').replace('/api', '');

let sharedSocket: Socket | null = null;

export const useSocket = (
  role?: string,
  branchId?: string,
  handlers?: {
    onTransactionNew?: (data: any) => void;
    onBookingNew?: (data: any) => void;
    onStockUpdate?: (data: any) => void;
    onStockLow?: (data: any) => void;
  }
) => {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  const connect = useCallback(() => {
    if (!sharedSocket) {
      sharedSocket = io(SOCKET_URL, {
        transports: ['websocket', 'polling'],
        reconnectionAttempts: 5,
        reconnectionDelay: 2000,
      });
    }

    const socket = sharedSocket;

    socket.on('connect', () => {
      console.log('[Socket] Connected:', socket.id);
      if (role || branchId) {
        socket.emit('join', { role, branch_id: branchId });
      }
    });

    socket.on('transaction:new', (data) => handlersRef.current?.onTransactionNew?.(data));
    socket.on('booking:new', (data) => handlersRef.current?.onBookingNew?.(data));
    socket.on('stock:update', (data) => handlersRef.current?.onStockUpdate?.(data));
    socket.on('stock:low', (data) => handlersRef.current?.onStockLow?.(data));

    socket.on('disconnect', () => console.log('[Socket] Disconnected'));
    socket.on('connect_error', (err) => console.warn('[Socket] Error:', err.message));

    return socket;
  }, [role, branchId]);

  useEffect(() => {
    const socket = connect();
    return () => {
      socket.off('transaction:new');
      socket.off('booking:new');
      socket.off('stock:update');
      socket.off('stock:low');
    };
  }, [connect]);
};
